import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"
import getMediaUrl from "utils/getMediaUrl"
import HighwayPurple from "../mapAssets/highway-purple.png"
import HighwayOrange from "../mapAssets/highway-orange.png"
import HighwayTeal from "../mapAssets/highway-teal.png"
import HighwayYellow from "../mapAssets/highway-yellow.png"

import {
  StyledContainer,
  StyledContentContainer,
  StyledName,
  StyledTime,
  StyledRampInfo,
  StyledFirstLine,
  StyledIcon,
  StyledPointIcon,
  StyledLine,
} from "./HighwayInfoLabel.styles"

const pins = {
  orange: HighwayOrange,
  teal: HighwayTeal,
  yellow: HighwayYellow,
  purple: HighwayPurple,
}

const HighwayInfoLabel = ({ aproxTime, name, colors, icon }) => {
  const { formatMessage } = useIntl()

  return (
    <StyledContainer>
      {icon && <StyledIcon src={getMediaUrl(icon)} alt={name} />}
      <StyledLine color={colors.body} />
      <StyledContentContainer>
        <StyledFirstLine>
          <StyledName>{name}</StyledName>
          {aproxTime && <StyledTime>({aproxTime})</StyledTime>}
        </StyledFirstLine>

        <StyledRampInfo>
          <StyledPointIcon src={pins[colors.name]} />
          {formatMessage({
            id: `pages.portfolio.project.location.accessibility.ramp`,
          })}
        </StyledRampInfo>
      </StyledContentContainer>
    </StyledContainer>
  )
}

HighwayInfoLabel.propTypes = {
  aproxTime: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.shape({
      original: PropTypes.string,
      large: PropTypes.string,
      medium: PropTypes.string,
      small: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  colors: PropTypes.shape({
    name: PropTypes.string,
    body: PropTypes.string,
    border: PropTypes.string,
  }).isRequired,
}
HighwayInfoLabel.defaultProps = {
  aproxTime: null,
  name: null,
  icon: null,
}
export default HighwayInfoLabel
